<template>
  <div>
    <manage-product-likeables-modal ref="manageLikeableModal"/>
    <manage-product-category-likeables-modal ref="manageProductCategoryLikeableModal"/>
    <v-container fluid>
      <v-layout row wrap>
        <v-flex xs12 sm4>
          <v-card class="mr-2">
            <v-toolbar color="red" dark height="48">
              <v-toolbar-title>{{ `app.interview.allergy`|trans }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn icon @click="openManageLikeablesModal(APPROACHES.ALLERGIC, TYPES.PRODUCT_TYPE)" v-on="on">
                    <v-icon>add</v-icon>
                  </v-btn>
                </template>
                <span>{{ `app.add_product` | trans }}</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn icon @click="openManageProductCategoryLikeablesModal(APPROACHES.ALLERGIC)" v-on="on">
                    <v-icon>grading</v-icon>
                  </v-btn>
                </template>
                <span>{{ `app.likeable.add_categories_and_subcategories` | trans }}</span>
              </v-tooltip>
            </v-toolbar>

            <v-list>
<!--              <template>-->
<!--                <v-subheader>-->
<!--                  Grupy produktowe-->
<!--                </v-subheader>-->
<!--              </template>-->
<!--              <template v-for="item in getLikeables(TYPES.PRODUCT_CATEGORY_TYPE, APPROACHES.ALLERGIC)">-->
<!--                <v-list-tile-->
<!--                    :key="item.id"-->
<!--                    @click=""-->
<!--                >-->
<!--                  <v-list-tile-content>-->
<!--                    <v-list-tile-title v-html="item.name"></v-list-tile-title>-->
<!--                  </v-list-tile-content>-->

<!--                  <v-list-tile-action>-->
<!--                    <v-btn icon ripple>-->
<!--                      <v-icon color="red" @click="deleteLikeable(item)">delete</v-icon>-->
<!--                    </v-btn>-->
<!--                  </v-list-tile-action>-->
<!--                </v-list-tile>-->
<!--              </template>-->
<!--              <template>-->
<!--                <v-divider-->
<!--                    :inset="false"-->
<!--                ></v-divider>-->
<!--              </template>-->
              <v-subheader>
                {{ `app.pages.products.products` | trans }}
              </v-subheader>
              <template v-for="item in getLikeables(TYPES.PRODUCT_TYPE, APPROACHES.ALLERGIC)">
                <v-list-tile
                    :key="item.id"
                    @click=""
                >
                  <v-list-tile-content>
                    <v-list-tile-title v-html="item.name"></v-list-tile-title>
                  </v-list-tile-content>

                  <v-list-tile-action>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn icon ripple v-on="on">
                          <v-icon color="red" @click="deleteLikeable(item)">delete</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ `app.pages.home.remove_product` | trans }}</span>
                    </v-tooltip>
                  </v-list-tile-action>
                </v-list-tile>
              </template>
            </v-list>
          </v-card>
        </v-flex>

        <v-flex xs12 sm4>
          <v-card>
            <v-toolbar color="orange" dark height="48">
              <v-toolbar-title>{{ `app.interview.unlike` | trans }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn icon @click="openManageLikeablesModal(APPROACHES.DO_NOT_LIKE, TYPES.PRODUCT_TYPE)" v-on="on">
                    <v-icon>add</v-icon>
                  </v-btn>
                </template>
                <span>{{ `app.add_product` | trans }}</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn icon @click="openManageProductCategoryLikeablesModal(APPROACHES.DO_NOT_LIKE)" v-on="on">
                    <v-icon>grading</v-icon>
                  </v-btn>
                </template>
                <span>{{ `app.likeable.add_categories_and_subcategories` | trans }}</span>
              </v-tooltip>
            </v-toolbar>

            <v-list>
<!--              <template>-->
<!--                <v-subheader>-->
<!--                  Grupy produktowe-->
<!--                </v-subheader>-->
<!--              </template>-->
<!--              <template v-for="item in getLikeables(TYPES.PRODUCT_CATEGORY_TYPE, APPROACHES.DO_NOT_LIKE)">-->
<!--                <v-list-tile-->
<!--                    :key="item.id"-->
<!--                    @click=""-->
<!--                >-->
<!--                  <v-list-tile-content>-->
<!--                    <v-list-tile-title v-html="item.name"></v-list-tile-title>-->
<!--                  </v-list-tile-content>-->

<!--                  <v-list-tile-action>-->
<!--                    <v-btn icon ripple>-->
<!--                      <v-icon color="red" @click="deleteLikeable(item)">delete</v-icon>-->
<!--                    </v-btn>-->
<!--                  </v-list-tile-action>-->
<!--                </v-list-tile>-->
<!--              </template>-->
<!--              <template>-->
<!--                <v-divider-->
<!--                    :inset="false"-->
<!--                ></v-divider>-->
<!--              </template>-->
              <v-subheader>
                {{ `app.pages.products.products` | trans }}
              </v-subheader>
              <template v-for="item in getLikeables(TYPES.PRODUCT_TYPE, APPROACHES.DO_NOT_LIKE)">
                <v-list-tile
                    :key="item.id"
                    @click=""
                >
                  <v-list-tile-content>
                    <v-list-tile-title v-html="item.name"></v-list-tile-title>
                  </v-list-tile-content>

                  <v-list-tile-action>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn icon ripple v-on="on">
                          <v-icon color="red" @click="deleteLikeable(item)">delete</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ `app.pages.home.remove_product` | trans }}</span>
                    </v-tooltip>
                  </v-list-tile-action>
                </v-list-tile>
              </template>
            </v-list>
          </v-card>
        </v-flex>

        <v-flex xs12 sm4>
          <v-card class="ml-2">
            <v-toolbar color="green" dark height="48">
              <v-toolbar-title>{{ `app.interview.like` | trans }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn icon @click="openManageLikeablesModal(APPROACHES.LIKE, TYPES.PRODUCT_TYPE)" v-on="on">
                    <v-icon>add</v-icon>
                  </v-btn>
                </template>
                <span>{{ `app.add_product` | trans }}</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn icon @click="openManageProductCategoryLikeablesModal(APPROACHES.LIKE)" v-on="on">
                    <v-icon>grading</v-icon>
                  </v-btn>
                </template>
                <span>{{ `app.likeable.add_categories_and_subcategories` | trans }}</span>
              </v-tooltip>
            </v-toolbar>

            <v-list>
<!--              <template>-->
<!--                <v-subheader>-->
<!--                  Grupy produktowe-->
<!--                </v-subheader>-->
<!--              </template>-->
<!--              <template v-for="item in getLikeables(TYPES.PRODUCT_CATEGORY_TYPE, APPROACHES.LIKE)">-->
<!--                <v-list-tile-->
<!--                    :key="item.id"-->
<!--                    @click=""-->
<!--                >-->
<!--                  <v-list-tile-content>-->
<!--                    <v-list-tile-title v-html="item.name"></v-list-tile-title>-->
<!--                  </v-list-tile-content>-->

<!--                  <v-list-tile-action>-->
<!--                    <v-btn icon ripple>-->
<!--                      <v-icon color="red" @click="deleteLikeable(item)">delete</v-icon>-->
<!--                    </v-btn>-->
<!--                  </v-list-tile-action>-->
<!--                </v-list-tile>-->
<!--              </template>-->
<!--              <template>-->
<!--                <v-divider-->
<!--                    :inset="false"-->
<!--                ></v-divider>-->
<!--              </template>-->
              <v-subheader>
                {{ `app.pages.products.products` | trans }}
              </v-subheader>
              <template v-for="item in getLikeables(TYPES.PRODUCT_TYPE, APPROACHES.LIKE)">
                <v-list-tile
                    :key="item.id"
                    @click=""
                >
                  <v-list-tile-content>
                    <v-list-tile-title v-html="item.name"></v-list-tile-title>
                  </v-list-tile-content>

                  <v-list-tile-action>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn icon ripple v-on="on">
                          <v-icon color="red" @click="deleteLikeable(item)">delete</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ `app.pages.home.remove_product` | trans }}</span>
                    </v-tooltip>
                  </v-list-tile-action>
                </v-list-tile>
              </template>
            </v-list>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout row wrap >
        <v-flex xs12>
          <v-textarea
              :label="'app.interview.other_allergy' | trans"
              v-model="otherAllergy"
              rows="4"
              solo
              class="mt-4"
          ></v-textarea>
        </v-flex>
      </v-layout>
    </v-container>
    <v-divider v-if="showSaveButton"></v-divider>
    <v-container fluid v-if="showSaveButton">
      <v-layout align-center justify-end>
        <v-btn @click="back()">{{ 'app.cancel' | trans }}</v-btn>
        <v-btn @click="saveDuringEditing()" color="primary" :loading="loading">{{ 'app.save' | trans }}</v-btn>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import {trans} from "../../../app";
import {mapGetters, mapActions} from "vuex";
import {helpers} from "../../../helpers";
import {APPROACHES, TYPES} from "../../../helpers/likeables";

export default {
  props: {
    showSaveButton: {
      type: Boolean,
      required: false,
      default: false
    },
  },
  created() {
    if (this.interview.id !== null) {
      this.otherAllergy = this.interview.other_allergy;
    }
  },
  data() {
    return {
      TYPES,
      APPROACHES,
      model: {
        products: [],
      },
      formValid: false,
      loading: false,
      productsLoading: false,
      selectedProduct: null,
      items: [],
      productSearch: null,
      hint: undefined,
      currentTimeout: null,
      otherAllergy: null
    }
  },
  computed: {
    ...mapGetters(['patient', 'interview', 'likeables']),
  },
  methods: {
    ...mapActions(['updateInterview', 'fetchLikeables', 'fetchInterview']),
    getLikeables(type, approach) {
      return this.likeables.filter(likeable => likeable.approach === approach && likeable.type === type);
    },
    openManageLikeablesModal(mode, type) {
      this.$refs.manageLikeableModal.open(mode, type);
    },
    openManageProductCategoryLikeablesModal(approach) {
      this.$refs.manageProductCategoryLikeableModal.openModal(approach);
    },
    back() {
      this.$emit('canceled');
    },
    async deleteLikeable(item) {
      const confirmText = item.type === TYPES.PRODUCT_TYPE
        ? trans('app.likeable.confirm_product_removal', {product: item.name})
        : trans('app.likeable.confirm_product_category_removal', {category: item.name});
      const confirm = await this.$confirm(confirmText, {
        title: trans('app.likeable.delete_title')
      });

      if (confirm) {
        axios
            .delete(`/v2/patients/${this.patient.id}/likeables/${item.id}`)
            .then(() => {
              this.$toast(trans('app.actions.removed', {name: trans('app.product').toLowerCase()}));
              this.fetchLikeables({patientId: this.patient.id});
            })
            .catch(() => {
              this.$toast.error('app.error_occurred');
            });
      }
    },
    saveDuringEditing() {
      if (this.interview.other_allergy !== this.otherAllergy) {
        this.loading = true;
        const updatedInterview = helpers.deepClone(this.interview);
        updatedInterview.other_allergy = this.otherAllergy;

        this.updateInterview(updatedInterview)
            .then(() => {
              this.$toast.success(trans('app.actions.saved', {name: trans('app.patients.panel.interview').toLowerCase()}));
              this.loading = false;
              this.fetchInterview({patientId: this.patient.id, interviewId: this.interview.id});
              this.$emit('saved');
            })
            .catch(() => this.$toast.error('app.error_occurred'));
        return;
      }
      this.$toast.success(trans('app.actions.saved', {name: trans('app.patients.panel.interview').toLowerCase()}));
      this.$emit('saved');
    },
    async save() {
      let updatedInterview = helpers.deepClone(this.interview);
      updatedInterview.other_allergy = this.otherAllergy;

      try {
        await this.updateInterview(updatedInterview);
      } catch (error) {
        this.$toast.error(trans('app.save_failed'));
        this.sentryCaptureException(error);
        return false;
      }

      this.$toast.success(trans('app.actions.saved', {name: trans('app.patients.panel.interview').toLowerCase()}));
      this.$emit('saved');
      return true;

    },
  },
  watch: {
    async productSearch(val) {
      this.clearTimeoutIfExists();
      this.items = [];
      this.hideNoDataText = true;

      if (!val) {
        this.hint = undefined;

        return;
      }

      this.hint = val.length > 0 && val.length < 3 ? trans('app.type_at_least_n_characters', {count: 3}) : undefined;

      if (val.length < 3) {
        return;
      }

      this.productsLoading = true;
      this.currentTimeout = setTimeout(async () => {
        const body = {
          q: val,
          excluded_id: this.model.products.map(modelProduct => modelProduct.uuid)
        };
        const response = await axios.post(`/foods/all-search.json`, body);
        this.items = response.data;
        this.productsLoading = false;
        this.currentTimeout = null;
        this.hideNoDataText = false;
      }, 500);
    }
  }
}
</script>
<style scoped>
.radio-group-full-width >>> .v-input__control {
  width: 100%
}
::v-deep .v-list__tile{
  height: 32px;
}
</style>
